export const managerPrices = {
  page: {
    title: "Prezzi della piattaforma",
    subtitle: "Elenco dei prezzi dei piani della piattaforma",
  },
  table: {
    name: "Nome",
    type: "Tipo",
    price: "Prezzo",
    created: "Creato",
    edit: "Modifica prezzo",
  },
  form: {
    title: "Aggiorna prezzo",
    planName: "Nome del piano",
    planType: "Tipo di piano",
    annual: "Annuale",
    monthly: "Mensile",
    cancel: "Annulla",
    save: "Salva",
  },
  toast: {
    saved: "Salvato con successo",
    error: "Errore nella richiesta",
  },
};
